const DEFAULT_LOCALE = "sv-SE";

export default DEFAULT_LOCALE;
